export default function checkIfRequired(string) {
  try {
    return JSON.parse(string)
  } catch (error) {
    return false
  }
}
